import {useCallback} from 'react';
import {ReactElement, useState} from 'react';

import {AlertColor} from '@mui/material/Alert/Alert';

import {SnackBarContext, SnackBarMessage} from './SnackBarContext';

interface Props {
  children: ReactElement;
}
export const SnackBarProvider = ({children}: Props) => {
  const [message, setMessage] = useState<SnackBarMessage>();

  const dispatchMessage = useCallback(
    (incomingMessage: string, severity: AlertColor) => {
      setMessage({
        text: incomingMessage,
        severity,
      });
    },
    [setMessage]
  );

  const clearMessage = () => {
    setMessage(undefined);
  };

  return (
    <SnackBarContext.Provider value={{dispatchMessage, clearMessage, message}}>{children}</SnackBarContext.Provider>
  );
};
